import { ReactElement } from 'react';

export const CloseIcon = ({ className, onClick }: { className: string; onClick: VoidFunction }): ReactElement => (
	<svg
		className={className}
		onClick={onClick}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M19 5L5 19" stroke="#7B829A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M5 5L19 19" stroke="#7B829A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);
